/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'
import variablesApplicationConfig from '../../../../variables'

export const ContainerSectionHeroInternacional = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;

  animation: all 0.6s ease-in-out;

  overflow-x: hidden;

  svg {
    &.svg-trail-background-svg {
      width: 100% !important;
    }
  }

  .middle-section {
    width: 100%;
    max-width: var(--max-width-section);

    display: flex;
    justify-content: space-between;

    margin-top: 60px;

    padding: 0px 60px;

    display: flex;

    color: ${(props) =>
      props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};

    .m-section-left {
      width: 100%;
      max-width: 620px;
      transition: all 0.6s ease-in-out;

      height: 600px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: start;

      opacity: 0;
      margin-left: -30px;

      .m-s-l-float-label {
        font-weight: 700;
        font-size: 18px;
        font-family: var(--secondary-font-family);

        display: flex;
        align-items: center;

        svg {
          margin-top: 6px;
          margin-left: 10px;
        }
      }

      .m-s-l-title {
        font-size: 80px;
        line-height: 90px;
        font-weight: bold;
        margin-top: 10px;
        transition: all 0.6s ease-in-out;

        color: black;
      }

      .m-s-l-button-action {
        display: flex;
        align-items: center;

        margin-top: 40px;
        margin-bottom: 60px;

        border-radius: 100px;

        border: 1px solid
          ${(props) =>
            props.color ? 'var(--primary-color)' : 'var(--secondary-color)'};
        background-color: var(--primary-color);
        color: white;

        padding: 20px 26px;
        font-weight: 600;

        cursor: pointer;

        svg {
          margin-top: 2px;
          margin-left: 10px;
          font-size: 18px;
        }
      }
    }
    .m-section-right {
      opacity: 0;
      margin-right: -30px;
      .radius-box-colored {
        width: 400px;
        height: 600px;

        margin-right: 40px;
        margin-bottom: 20px;

        border-radius: 20px;

        border: 5px solid
          ${(props) =>
            props.color ? 'var(--secondary-color)' : 'var(--primary-color)'};
        background-color: var(--background-color);

        position: relative;
        transition: all 0.6s ease-in-out;

        .floating-box-animated-jump {
          display: flex;
          align-items: center;

          background-color: white;

          padding: 10px 14px;

          border-radius: 10px;
          border: 0.5px solid #e3dbd8;

          animation: upAndDown 10s ease-in-out infinite;

          cursor: pointer;

          transition: all 0.6s ease-in-out;

          &.type-01 {
            position: absolute;

            top: 30px;
            left: -65px;
            animation-delay: 0s;
          }

          &.type-02 {
            position: absolute;

            top: 230px;
            left: -35px;
            animation-delay: 0.5s;
          }

          &.type-03 {
            position: absolute;

            top: 400px;
            left: -105px;
            animation-delay: 1s;
          }

          &.type-04 {
            position: absolute;

            top: 90px;
            right: -75px;
            animation-delay: 1.5s;
          }

          &.type-05 {
            position: absolute;

            top: 330px;
            right: -75px;
            animation-delay: 2s;
          }

          .circular {
            width: 40px;
            height: 40px;

            border-radius: 40px;
            border: 1px solid var(--primary-color);
            background-color: var(--background-color);

            margin-right: 14px;
          }
        }
      }
    }
  }

  @keyframes upAndDown {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-20px);
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.desktopBreakpoint}px) {
    .m-section-left {
      max-width: 500px !important;
      .m-s-l-title {
        font-size: 64px !important;
        line-height: 74px !important;
        font-weight: bold;
        margin-top: 10px;
      }
      .m-s-l-button-action {
        margin-bottom: 140px !important;
      }
    }
    .m-section-right {
      .radius-box-colored {
        width: 360px !important;
        height: 500px !important;
      }
    }
  }
  @media (max-width: ${() => variablesApplicationConfig.tabletBreakpoint}px) {
    .middle-section {
      justify-content: flex-start;
      flex-direction: column;
      align-items: center;
      margin-top: 120px;
      .m-section-left {
        height: 400px !important;
        align-items: center;
        .m-s-l-float-label {
          text-align: center;
        }
        .m-s-l-title {
          text-align: center;
        }
        .m-s-l-button-action {
          margin-bottom: 50px !important;
        }
      }
      .m-section-right {
        margin-top: 100px;
      }
    }
  }

  @media (max-width: ${() => variablesApplicationConfig.mobileBreakpoint}px) {
    .middle-section {
      margin-top: 66px;
      padding: 0px 30px;
      .m-section-left {
        .m-s-l-float-label {
          gap: 10px;
          flex-direction: column;
        }
        .m-s-l-title {
          font-size: 40px !important;
          line-height: 50px !important;
        }
      }
      .m-section-right {
        .radius-box-colored {
          width: 280px !important;
          margin-right: 0px !important;

          .floating-box-animated-jump {
            &.type-01 {
              left: -30px;
            }

            &.type-02 {
              left: -45px;
            }

            &.type-03 {
              left: -30px;
            }

            &.type-04 {
              right: -30px;
            }

            &.type-05 {
              right: -35px;
            }
          }
        }
      }
    }
  }
`
